import React from "react";
import { REWARD_OFFERING } from "../../constants";
import OnboardingPage from "../../common/components/OnboardingPage";
import { getRedeemUrlWithContext } from "../../utils";

function EuropcarTactical3Main() {
  const redeemUrl = getRedeemUrlWithContext("europcar-tactical-3");

  return (
    <>
      <OnboardingPage
        redeemUrl={redeemUrl}
        rewardId={REWARD_OFFERING.europcartactical3}
      />
    </>
  );
}

export default EuropcarTactical3Main;
